import { render, staticRenderFns } from "./ComplexionCheck.vue?vue&type=template&id=dd095018&scoped=true&"
import script from "./ComplexionCheck.vue?vue&type=script&lang=js&"
export * from "./ComplexionCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd095018",
  null
  
)

export default component.exports